import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zM7 20.648V20a5 5 0 1110 0v.648a9.918 9.918 0 01-10 0zM9 10a3 3 0 116 0 3 3 0 01-6 0zm9.948 9.177a7 7 0 00-3.726-5.384 5 5 0 10-6.444 0 7 7 0 00-3.726 5.384 10 10 0 1113.896 0z" fill="#BFBFBF" /></svg>;